import { render, staticRenderFns } from "./IconInstagram.vue?vue&type=template&id=e173f134&"
import script from "./IconInstagram.vue?vue&type=script&lang=js&"
export * from "./IconInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports